import { useSite } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METAFIELD_QUERY_KEY } from './use-metafield-configuration';
import { usePlatformApi } from './use-platform-api';

export function useEnableMetafield() {
  const { platformApi } = usePlatformApi();
  const site = useSite();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>({
    mutationFn: (key) => platformApi.enableMetafield(site.siteId, site.siteEnv, key),
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [METAFIELD_QUERY_KEY, site.siteId, site.siteEnv],
      });
    },
  });
}
